module.exports = __webpack_public_path__ + "img/camera.97e87296.svg";